import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { installDomTranslateGuard } from './lib/domTranslateGuard'
import { captureReferralFromUrl } from './lib/referral'
import { installErrorReporter } from './lib/errorReporter'

// Erros de JavaScript do navegador → servidor (01/11/2026; antes só o Clarity via o total, sem detalhe).
installErrorReporter()

// Instalado ANTES de qualquer render — precisa estar ativo desde o primeiro
// paint, já que o tradutor do navegador pode mexer no DOM a qualquer momento.
installDomTranslateGuard()

// Link de indicação antigo (?ref=<código>): guarda o código para o cadastro (28/10/2026).
captureReferralFromUrl()

// Falha ao carregar um chunk lazy (aba aberta antes de um deploy, rede instável): o Vite dispara
// este evento ANTES de o erro chegar ao React. Recarregamos em silêncio (uma vez a cada 15s, com
// query única pra baixar o index.html novo) e suprimimos o erro, evitando a "telinha de erro".
window.addEventListener('vite:preloadError', (event) => {
  let last = 0
  try { last = Number(sessionStorage.getItem('clinica_preload_reload_at') || 0) } catch { /* storage bloqueado */ }
  if (Date.now() - last < 15000) return // já tentou agora há pouco: deixa o ErrorBoundary tratar
  try { sessionStorage.setItem('clinica_preload_reload_at', String(Date.now())) } catch { /* ignora */ }
  event.preventDefault()
  const { pathname, search, hash } = window.location
  const clean = search.replace(/([?&])_cln_reload=\d+&?/, '$1').replace(/[?&]$/, '')
  const sep = clean ? '&' : '?'
  window.location.replace(`${pathname}${clean}${sep}_cln_reload=${Date.now()}${hash}`)
})

createRoot(document.getElementById('root')!).render(
  <App />,
)

// Registro do Service Worker — necessário pro PWA ser instalável (Chrome/
// Edge/Android só disparam beforeinstallprompt com um SW ativo). O SW em si
// (public/sw.js) nunca intercepta /api/* nem requisições com corpo — ver
// comentário lá.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Falha de registro não deve travar nada — PWA é progressivo por definição.
    })
  })
}
